<div class="d-flex px-md-5 px-2 justify-content-center sc-security">
  <div class="col-lg-11">

    <div class="dash-panel">
      <h3 class="dash-section-title">Security</h3>

      <div class="sc-form-body">

        @if (!user.has_password) {
          <p class="sc-hint">Password must contain at least 6 characters.</p>
          <form [formGroup]="SetPasswordForm" (ngSubmit)="OnSetPassword()">
            <div class="row g-3 align-items-end">
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="sc-field-label" for="setFirstPassword">New Password</label>
                  <input type="password" formControlName="setFirstPassword" class="form-control" [ngClass]="{ 'is-invalid':SetPasswordFormControl.setFirstPassword.errors }" />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="sc-field-label" for="setSecondPassword">Repeat New Password</label>
                  <input type="password" formControlName="setSecondPassword" class="form-control" [ngClass]="{ 'is-invalid':SetPasswordFormControl.setSecondPassword.errors }" />
                </div>
              </div>
              <div class="col-sm-4">
                <button [disabled]="!SetPasswordForm.valid" class="btn btn-sm btn-primary">
                  Set Password
                </button>
              </div>
            </div>
          </form>
        }

        @if (user.has_password && isChangingPassword) {
          <p class="sc-hint">Password must contain at least 6 characters.</p>
          <form [formGroup]="UpdatePasswordForm" (ngSubmit)="OnPasswordUpdate()">
            <div class="row g-3 align-items-end">
              <div class="col-sm-3">
                <div class="form-group">
                  <label class="sc-field-label" for="updateLastPassword">Last Password</label>
                  <input type="password" formControlName="updateLastPassword" class="form-control" [ngClass]="{ 'is-invalid': UpdatePasswordFormControl.updateLastPassword.errors }" />
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label class="sc-field-label" for="updateFirstPassword">New Password</label>
                  <input type="password" formControlName="updateFirstPassword" class="form-control" [ngClass]="{ 'is-invalid':UpdatePasswordFormControl.updateFirstPassword.errors }" />
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label class="sc-field-label" for="updateSecondPassword">Repeat New Password</label>
                  <input type="password" formControlName="updateSecondPassword" class="form-control" [ngClass]="{ 'is-invalid':UpdatePasswordFormControl.updateSecondPassword.errors }" />
                </div>
              </div>
              <div class="col-sm-3">
                <button [disabled]="!UpdatePasswordForm.valid" class="btn btn-sm btn-primary">
                  Update
                </button>
              </div>
            </div>
          </form>
        }

        @if (user.has_password && !isChangingPassword) {
          <div class="dash-row">
            <p class="dash-label">Password</p>
            <p class="dash-value sc-ok-inline">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
              </svg>
              Your password is set.
            </p>
            <button (click)="OnPasswordUpdate()" class="btn btn-sm btn-primary">
              Change Password
            </button>
          </div>
        }

      </div>
    </div>

  </div>
</div>
